import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import { Link } from '@inertiajs/inertia-vue3';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {
    tenatList: Object,
    defaultTenant: String
  },
  data: function data() {
    return {
      tenantId: this.defaultTenant,
      campaignList: [],
      isLoadingCampaigns: false,
      isLoadingPaginate: false,
      currentPage: 1,
      totalCount: 0,
      showSettings: false,
      campaignSettings: {
        campaignId: '',
        emailType: 'automatic',
        emailsPerDay: 200,
        emailsPerDayTotal: 1000,
        emailsPerMinute: 5,
        contactsPerCompany: 2,
        follow_up_time: '00:00:00',
        follow_up_end_time: '00:00:00',
        tenantId: '',
        follow_interval: []
      }
    };
  },
  mounted: function mounted() {
    this.getCampaigns(true);
  },
  methods: {
    getCampaigns: function getCampaigns() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var resetPaginate, data, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resetPaginate = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                _this.isLoadingCampaigns = true;
                data = {
                  tenantId: _this.tenantId,
                  page: _this.currentPage
                };
                if (resetPaginate) {
                  _this.isLoadingPaginate = true;
                  data['get_total'] = true;
                }
                _context.next = 6;
                return axios.post('/campaigns/list', data);
              case 6:
                res = _context.sent;
                _this.campaignList = res.data.campaignList;
                if (resetPaginate) {
                  _this.totalCount = res.data.total;
                }
                _this.isLoadingCampaigns = false;
                _this.isLoadingPaginate = false;
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    pageChange: function pageChange(page) {
      this.currentPage = page;
      this.getCampaigns();
    },
    getCampaignStatusClass: function getCampaignStatusClass(status) {
      return {
        'pill active w-20': status == 'active',
        'pill pause w-20': status == 'pause',
        'pill suspend w-20': status == 'suspended',
        'pill pending w-20': status == 'pending'
      };
    },
    showCampaignSettings: function showCampaignSettings(campaign) {
      this.campaignSettings.tenantId = campaign.tenant_id;
      this.campaignSettings.emailType = campaign.email_type;
      this.campaignSettings.campaignId = campaign.id;
      this.campaignSettings.emailsPerDay = campaign.emails_per_day;
      this.campaignSettings.emailsPerDayTotal = campaign.emails_per_day_total;
      this.campaignSettings.emailsPerMinute = campaign.emails_per_minute;
      this.campaignSettings.contactsPerCompany = campaign.contacts_per_company;
      this.campaignSettings.follow_up_time = campaign.follow_up_time;
      this.campaignSettings.follow_up_end_time = campaign.follow_up_end_time;
      this.campaignSettings.follow_interval = campaign.follow_interval;
      this.showSettings = true;
    },
    saveCampaignSettings: function saveCampaignSettings() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.loading = true;
                _context2.next = 3;
                return axios.post('/campaigns/save-settings', _this2.campaignSettings);
              case 3:
                res = _context2.sent;
                _this2.$store.loading = false;
                _context2.next = 7;
                return _this2.resetCampaignSettings();
              case 7:
                _context2.next = 9;
                return _this2.getCampaigns();
              case 9:
                ElMessage({
                  showClose: true,
                  message: res.data.message,
                  type: res.data.status
                });
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    resetCampaignSettings: function resetCampaignSettings() {
      this.campaignSettings = {
        campaignId: '',
        emailType: 'automatic',
        emailsPerDay: 200,
        emailsPerDayTotal: 1000,
        emailsPerMinute: 5,
        contactsPerCompany: 2,
        follow_up_time: '00:00:00',
        follow_up_end_time: '00:00:00',
        tenantId: '',
        follow_interval: []
      };
      this.showSettings = false;
    },
    navigateToBulkUpdate: function navigateToBulkUpdate() {
      this.$inertia.visit('/campaigns/bulk-update');
    }
  }
};